// Angular
import { Routes } from "@angular/router";

// Templates
import { TemplateLoggedInComponent } from "#components/template-logged-in/template-logged-in.component";
import { TemplateGuestComponent } from "#components/template-guest/template-guest.component";

// Guards
import { PermissionGuard } from "#guards/permission/permission.guard";
import { AuthGuard } from "#guards/auth/auth.guard";

// Models
import { AppRoute, AppRoutes, RegistrationPrivateRouteData, RouteData } from "#models/router";
import { Permission } from "#models/permissions";

// Variables
import { AUTH_PATH } from "#src/app/shared/variables/routes";

// import { ProfileComponent } from "#pages/profile/profile.component";

const getPrivateRoute = (
    path: string | undefined,
    loadChildren: Promise<RouteData>,
    can?: Permission
): AppRoute => {
    return {
        path,
        loadChildren: () => loadChildren.then((m) => m.ROUTES),
        ...(can
            ? {
                  canActivate: [PermissionGuard],
                  data: { can },
              }
            : {}),
    };
};

const getPrivateRoutes = (routes: RegistrationPrivateRouteData[]): AppRoutes => {
    return routes.map((route) => getPrivateRoute(...route));
};

// Private routes
const privateRoutes: AppRoutes = getPrivateRoutes([
    // Solo
    ["", import("#pages/home/home.routes")],
    ["profile", import("#pages/profile/profile.routes")],
    ["roles", import("#pages/roles/roles.routes")],
    ["permissions", import("#pages/permissions/permissions.routes")],
    ["config", import("#pages/config/config.routes"), "configView"],

    // Users
    ["users", import("#pages/users/users.routes"), "userView"],
    ["users/create", import("#pages/create-user/create-user.routes"), "userAdd"],
    ["users/edit/:id", import("#pages/edit-user/edit-user.routes"), "userEdit"],
    ["users/:id", import("#pages/user/user.routes"), "userView"],

    // GDS
    ["gds", import("#pages/gds/gds.routes"), "gdsView"],

    // PTC
    ["ptc", import("#pages/ptc/ptc.routes"), "ptcView"],

    // Corporate IDs
    ["corporate-ids", import("#pages/corporate-ids/corporate-ids.routes"), "corporateView"],

    // Consolidators
    ["consolidators", import("#pages/consolidators/consolidators.routes"), "consolidatorView"],
    ["consolidators/:id", import("#pages/consolidator/consolidator.routes"), "consolidatorView"],

    // Errors
    ["403", import("#pages/error-403/error-403.routes")],

    // Base
    ["**", import("#pages/error-404/error-404.routes")],
]);

// Public routes
const publicRoutes: Routes = [
    {
        path: AUTH_PATH,
        canActivate: [AuthGuard],
        component: TemplateGuestComponent,
        loadChildren: () => import("#pages/auth/auth.routes").then((m) => m.ROUTES),
    },
    {
        path: "404",
        component: TemplateGuestComponent,
        loadChildren: () => import("#pages/error-404/error-404.routes").then((m) => m.ROUTES),
    },
];

export const routes: AppRoutes = [
    ...publicRoutes,
    {
        path: "",
        canActivate: [AuthGuard],
        component: TemplateLoggedInComponent,
        children: privateRoutes,
    },
    {
        path: "**",
        component: TemplateGuestComponent,
        loadChildren: () => import("#pages/error-404/error-404.routes").then((m) => m.ROUTES),
    },
];
